module.exports = __webpack_public_path__ + "img/KS.18c27a5f.png";